<template>
  <div id="supplier">
    <div class="card">
      <h2>Lieferanten</h2>
      <div v-if="!showProductList" class="letter-link-cont">
        <a v-for="letter in letters" :href="'#letter-' + letter">
          <span class="letter-link"
                v-if="getSuppplierStartsWith(letter).length > 0">
            {{letter}}
          </span>
        </a>
      </div>
      <hr v-if="!showProductList" />
      <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6">
          <Dropdown
            @change="updateReps"
            :filter="true"
            v-model="selectedSupplier"
            :options="allSuppliers"
            optionLabel="name"
            placeholder="Lieferanten auswählen"
          />
        </div>
      </div> -->
      <div class="supplier-card-list-cont" v-if="!showProductList">
        <template v-for="letter in letters">
          <div :id="'letter-' + letter" class="w-full p-m-2 p-m-4" :key="letter">
            <h2
              v-if="getSuppplierStartsWith(letter).length > 0"
              class="p-mt-2"
            >
              {{ letter }}
            </h2>
            <div
              v-for="supplier in getSuppplierStartsWith(letter)"
              :key="supplier._id"
              class="card-container supplier-box p-mb-2"
              style="display: inline-block"
            >
              <router-link :to="{ name: 'specific.supplier', params: {supplierId: supplier.supplierId } }">
                <Card class="p-mr-2 logo-card">
                  <template slot="header">
                    <img
                      alt="Supplier Logo"
                      src="https://via.placeholder.com/150"
                    />
                  </template>
                  <template slot="content">
                    {{
                        supplier.name
                      }}
                  </template>
                </Card>
              </router-link>
            </div>
            <br />
          </div>
        </template>
      </div>
    </div>

    <div v-if="showProductList">
      <DataTable
        :value="representatives"
        :paginator="true"
        class="p-datatable-products"
        :rows="10"
        data-key="id"
        :filters="filters"
        :loading="loading"
      >
        <template #header>
          <div class="table-header">
            <span class="p-text-left p-float-left">
              {{ selectedSupplier.name }}
            </span>

            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <input class="p-inputtext p-component"
                     v-model="filters['global']"
                     placeholder="Suchen"
                     type="text"
              />
            </span>
          </div>
        </template>
        <template #empty>Keine Modelle gefunden.</template>
        <template #loading>Lade alle Modelle...</template>
        <Column field="productId" header="ID" sortable>
          <template #body="slotProps">
            <a href="#" @click="viewProduct(slotProps.data)">{{
              slotProps.data.productId
            }}</a>
          </template>
        </Column>
        <div class="p-fluid p-formgrid p-grid">
          <Column field="productNameByVme" header="Name By Vme" sortable>
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)"
                >{{
                  slotProps.data.pname !== ""
                    ? slotProps.data.pname
                    : slotProps.data.productNameByVme
                }}
              </a>
            </template>
          </Column>

          <Column
            field="productNameBySupplier"
            header="Name By Supplier"
            sortable
          >
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)">{{
                slotProps.data.productNameBySupplier
              }}</a>
            </template>
          </Column>

          <Column
            field="productNameByMerchant"
            header="Name By Merchant"
            sortable
          >
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)">{{
                slotProps.data.productNameByMerchant
              }}</a>
            </template>
          </Column>
        </div>
      </DataTable>
    </div>

    <Dialog
      header="Produktdetails"
      :visible.sync="display"
      :style="{ width: '50vw' }"
    >
      <h3>ID: {{ selectedProduct.productId }}</h3>
      <h1>
        Modell:
        {{
          selectedProduct.pname !== ""
            ? selectedProduct.pname
            : selectedProduct.productNameByVme
        }}
      </h1>
      <p>
        <b>Name by Supplier:</b><br />
        {{ selectedProduct.productNameBySupplier }}
      </p>
      <p>
        <b>Name by Merchant:</b><br />
        {{ selectedProduct.productNameByMerchant }}
      </p>
      <div class="model-img-cont">
        <img :src="selectedProduct.url" alt="Modellname" />
      </div>
      <p>
        <b>Beschreibung:</b><br />
        {{ selectedProduct.description }}
      </p>
      <p>
        <b>Lieferung (KW):</b>
        <span class="shipping-time">{{ selectedProduct.deliveryDate }}</span>
      </p>
      <p>
        <b>Hinweis:</b><br />
        Es kann zu Verzögerungen von 1 bis 2 Wochen kommen.
      </p>

      <p>
        <b>Hinweis:</b><br />
        Es kann zu Verzögerungen von 1 bis 2 Wochen kommen.
      </p>

      <p>
        <b>Shipping time:</b>
        {{ deliveryDate }} + {{ agreementTime }} =
        {{ shippingTime }}
      </p>

      <template #footer>
        <Button
          label="Ok"
          icon="pi pi-times-circle"
          @click="display = false"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FETCH_SUPPLIERS, FETCH_PRODUCTS } from "../../store/actions.type"
import Menubar from "primevue/menubar"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Dropdown from "primevue/dropdown"
import Checkbox from "primevue/checkbox"
import Dialog from "../../components/Dialog"
import Sidebar from "primevue/sidebar"
import "primeflex/primeflex.css"

import { mapGetters } from "vuex"
import axios from "axios"

export default {
  name: "suppliers",
  data() {
    return {
      suppliers: [],
      display: false,
      displayBasic2: false,
      freeCollection: false,
      filters: {},
      loading: true,
      showProductList: false,
      representatives: null,
      selectedSupplier: {},
      selectedProduct: {
        pname: "",
        description: "",
        price: "",
        deliveryDate: "",
      },
    }
  },
  mounted() {
    console.log(this.$msal)
  },
  methods: {
    fetchSuppliers() {
      this.$store.dispatch(FETCH_SUPPLIERS)
    },
    openBasic2() {
      this.displayBasic2 = true
    },
    viewProduct(product) {
      this.selectedProduct = product
      this.display = true
    },
    viewProductList(supplier) {
      this.showProductList = true
      this.selectedSupplier = supplier
      let params = {
        supplierId: supplier.supplierId,
        merchantId: 1,
        isNotSpecific: !!this.freeCollection.length,
      }
      let self = this
      this.$store.dispatch(FETCH_PRODUCTS, params)
        .then((res) => {
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    getSuppplierStartsWith(letter) {
      return this.allSuppliers.filter(sup => sup.name.startsWith(letter)
      )
    }
  },
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.$router.push("/login")
    }
    if (this.$msal.isAuthenticated()) {
      this.fetchSuppliers()
    }
  },
  computed: {
    ...mapGetters(["allSuppliers", "allProducts"]),
    shippingTime() {

      if (!this.selectedSupplier) {
        return
      }

      let deliveryDate = this.selectedProduct.deliveryDate ? this.selectedProduct.deliveryDate : 0
      let agreementTime = 0

      if (this.selectedSupplier.hasOwnProperty("agreementTime")) {
        agreementTime = this.selectedSupplier.agreementTime === null ||
          this.selectedSupplier.agreementTime === undefined ? 0 : this.selectedSupplier.agreementTime
      }

      let shippingTime = parseInt(deliveryDate) + parseInt(agreementTime)
      let shippingTimeWithsuffix = this.ordinalSuffix(shippingTime)

      return `${shippingTimeWithsuffix} CW`
    },
    letters() {
      let letters = []
      for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) { letters.push(String.fromCharCode([i])) }
      return letters
    },
    deliveryDate() {
      return this.selectedProduct.deliveryDate ? this.selectedProduct.deliveryDate : 0
    },
    agreementTime() {
      let agreementTime = 0

      if (!this.selectedSupplier) {
        return
      }

      if (this.selectedSupplier.hasOwnProperty("agreementTime")) {
        agreementTime = this.selectedSupplier.agreementTime === null || this.selectedSupplier.agreementTime === undefined ? 0 : this.selectedSupplier.agreementTime
      }

      return agreementTime
    }

  },
  watch: {
    allProducts(products) {
      this.representatives = products
    },
    freeCollection(val) {
      let params = {
        supplierId: this.selectedSupplier.supplierId,
        merchantId: "1",
        isNotSpecific: !!this.freeCollection.length,
      }
      this.$store.dispatch(FETCH_PRODUCTS, params)
    },
  },
  components: {
    Menubar,
    DataTable,
    Column,
    Dropdown,
    Checkbox,
    Dialog,
  },
};
</script>

<style lang="scss">
.shipping-time {
  font-weight: 800;
}
.card{
  padding: 2em;
}
.model-img-cont {
  margin: 0 auto;
}

.card-container {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}

.p-card .p-card-content {
  padding: 0 !important;
  text-align: center;
}

.clear:after {
  clear: both;
  content: "";
  display: table;
}

.model-img-cont img {
  max-width: 90%;
}

.p-button {
  background: #007ad9;
  border: 1px solid #007ad9;
}

.p-datatable .p-sortable-column.p-highlight {
  background: #969696;
  color: #ffffff;
}
.letter-link-cont{
  padding: 1.7em;
}

.letter-link{
  padding: 0.8em;
  font-size: 18pt;
}

.supplier-card-list-cont{
  padding-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/SuppliersList.vue